<template>
  <div :class="b()" :style="styleSizeName" ref="main" @click="handleClick">
    <!-- <span style="color:#fff">{{ option }}, {{ dataChart }}</span> -->
    <div ref="box" :class="b('box')">
      <!-- :href="linkHref"
       :target="linkTarget" -->
      <a ref="text" :class="b('text')" @click="goLink" :style="styleName">{{ value }}</a>
    </div>
  </div>
</template>

<script>
// import { parseUrl } from '@/utils/utils';
import init from '@/mixins/chart';
export default {
  name: 'text2',
  mixins: [init],
  data() {
    return {
      check: '',
      date: new Date(),
      left: 0
    };
  },
  computed: {
    scroll() {
      return this.vaildData(this.option.scroll, false);
    },
    linkHref() {
      return this.option.linkHref || '#';
    },
    linkTarget() {
      return this.option.linkTarget || '_self';
    },
    step() {
      return this.option.step || 5;
    },
    speed() {
      return this.option.speed || 100;
    },
    lineHeight() {
      return this.option.lineHeight || 40;
    },
    fontSize() {
      return this.option.fontSize || 30;
    },
    split() {
      return this.option.split;
    },
    textWidth() {
      const textLen = (this.dataChart.value || '').length;
      return textLen * this.fontSize;
    },
    styleName() {
      return {
        width: this.scroll ? this.setPx(this.textWidth) : 'auto',
        transform: 'translateX(' + this.left + 'px)',
        textAlign: this.option.textAlign,
        letterSpacing: this.setPx(this.split),
        textIndent: this.setPx(this.split),
        backgroundColor: this.option.backgroundColor,
        fontWeight: this.option.fontWeight || 'normal',
        fontSize: this.fontSize + 'px',
        lineHeight: this.lineHeight + 'px',
        color: this.option.color || '#333'
      };
    },
    value() {
      // const value = parseUrl(this.dataChart.value || '');
      const value = this.dataChart.value || '';
      return value;
    }
  },
  watch: {
    scroll() {
      this.move();
    },
    speed() {
      this.move();
    }
  },
  created() {
    setInterval(() => {
      this.date = new Date();
    }, 1000);
  },
  mounted() {
    this.move();
  },
  methods: {
    handleClick() {
      this.clickFormatter({
        data: this.dataChart
      });
    },
    goLink() {
      this.imgClick();
    },
    move() {
      clearInterval(this.check);
      if (this.scroll) {
        this.check = setInterval(() => {
          if (this.left < -this.textWidth) {
            this.left = this.width;
          }
          this.left = this.left - this.step;
        }, this.speed);
      } else {
        this.left = 0;
      }
    }
  },
  props: {
    option: {
      type: Object,
      default: () => {
        return {};
      }
    }
  }
};
</script>
